export default {
  busiStageList: [],
  busiOpportunityList: {},
  CustomSelectData: {},
  busiOpportunityDetail: {},
  busiVisitData: {},
  busiSalesData: {},
  busiFileData: {},
  busiLineList: [],
  busiSalesList: [],
  busiContacts: [],
  detailContacts: {},
  teamList: [],
};
